var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15c0 8.271 6.729 15 15 15s15-6.729 15-15S23.271 0 15 0 0 6.729 0 15z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.867c7.241 0 13.133 5.892 13.133 13.133 0 7.241-5.892 13.133-13.133 13.133C7.759 28.133 1.867 22.24 1.867 15 1.867 7.759 7.76 1.867 15 1.867z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.025 15a9.025 9.025 0 1 1-18.05 0 9.025 9.025 0 0 1 18.05 0",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapStructure);
export default __webpack_public_path__ + "static/media/map-structure.0cd32547014fac69432a2dd98fcce255.svg";
export { ForwardRef as ReactComponent };